import { render, staticRenderFns } from "./BoxVersionsSelect.vue?vue&type=template&id=2e36a4c0&scoped=true&"
import script from "./BoxVersionsSelect.vue?vue&type=script&lang=js&"
export * from "./BoxVersionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36a4c0",
  null
  
)

export default component.exports